import { FederatedEvent, IDestroyOptions, Point, Rectangle, TEXT_GRADIENT, TextStyle } from "pixi.js";
import { BaseTokenPanel } from "./BaseTokenPanel";
import { Event } from "../../../../../../../../shared/event-system/Event";
import { TokenType } from "../../../../../../../../web3/TokenType";
import { GameFont } from "../../../../../../common/GameFont";
import { TextWithUnderline } from "../../../../../../game/components/TextWithUnderline";
import { MyWalletResourcePackage } from "../../../../resources/MyWalletResourcePackage";

export class MONPanel extends BaseTokenPanel {
    private static readonly DESCRIPTION = "MON Protocol";
    private static readonly RECEIVE_TEXT = "RECEIVE";
    private static readonly SEND_TEXT = "SEND";

    public readonly onReceiveClick: Event<void>;
    public readonly onSendClick: Event<void>;

    private readonly receiveText: TextWithUnderline;
    private readonly sendText: TextWithUnderline;

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        balance: string
    ) {
        super(
            TokenType.MON,
            new Point(600, 235),
            myWalletResources.assets_views_my_wallet_ui_mon_token_icon_png,
            new MONTextStyle(),
            MONPanel.DESCRIPTION,
            balance
        );
        this.onReceiveClick = new Event();
        this.onSendClick = new Event();

        this.receiveText = new TextWithUnderline(MONPanel.RECEIVE_TEXT, new InteractionTextStyle());
        this.receiveText.position.set(50, 140);
        this.receiveText.hitArea = new Rectangle(0, -this.receiveText.height * 0.5, this.receiveText.width, this.receiveText.height * 2)
        this.receiveText.interactive = true;

        this.sendText = new TextWithUnderline(MONPanel.SEND_TEXT, new InteractionTextStyle());
        this.sendText.position.set(this.receiveText.position.x + this.receiveText.width + 341, this.receiveText.position.y);
        this.sendText.hitArea = new Rectangle(0, -this.sendText.height * 0.5, this.sendText.width, this.sendText.height * 2)
        this.sendText.interactive = true;

        this.addChild(
            this.receiveText,
            this.sendText
        );
        this.receiveText.on("pointerup", this.onReceiveTextClick, this);
        this.sendText.on("pointerup", this.onSendTextClick, this);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.receiveText.off("pointerup", this.onReceiveTextClick, this);
        this.sendText.off("pointerup", this.onSendTextClick, this);
        super.destroy(options);
    }

    private onReceiveTextClick(event: FederatedEvent): void {
        event.stopPropagation();
        this.onReceiveClick.emit();
    }

    private onSendTextClick(event: FederatedEvent): void {
        event.stopPropagation();
        this.onSendClick.emit();
    }
}

class MONTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 48,
            fontWeight: '400',
            fill: ["#FFFFC9", "#FFBA50", "#C96CB2"],
            fillGradientType: TEXT_GRADIENT.LINEAR_HORIZONTAL,
            fillGradientStops: [0.08, 0.55, 1.0]
        });
    }
}

class InteractionTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40,
            fontWeight: '400',
            fill: ["#AAFD09", "#16CF15"],
            fillGradientType: TEXT_GRADIENT.LINEAR_VERTICAL
        });
    }
}